import {
  Component,
  Directive,
  HostListener,
  Optional,
  Input,
  Output,
  EventEmitter
} from "@angular/core";

import { DrawerRef, Drawer } from "../../../drawer.service";

@Component({
  selector: "uex-drawer-dismiss",
  templateUrl: "./dismiss.component.html"
})
export class DrawerDismissComponent {
  @Input() public autodismiss = true;
  @Output() public color = "dark";
  @Output("click") private _onClick: EventEmitter<void> = new EventEmitter();

  constructor(@Optional() private _drawerRef: DrawerRef) {
    this._drawer = this._drawerRef.drawer;
  }

  private _drawer: Drawer;

  /**
   * @internal
   */
  public onClick(event: MouseEvent) {
    if (this._drawer && this.autodismiss) {
      this._drawer.dismiss();
    }
    this._onClick.emit();
  }
}

@Directive({
  selector: "[drawerDismiss], [drawer-dismiss]"
})
export class DrawerDismissDirective {
  constructor(@Optional() private _drawerRef: DrawerRef) {
    this._drawer = this._drawerRef.drawer;
  }

  private _drawer: Drawer;

  @HostListener("click") public _onClick() {
    if (this._drawer) {
      this._drawer.dismiss();
    }
  }
}
